module.exports = __webpack_public_path__ + "static/img/__9402.af2749a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9402.jpg
// module id = zFc1
// module chunks = 0